export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const str = value.toString();
  if (isNaN(Number(value))) return str;
  const parts = str.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};
